import { useCallback, useMemo, useState } from "react";

import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import DepartmentTableActions from "./components/table-action";
import SearchField from "../../../../../components/search-field";
import { useAttendanceLocalDepartmentList } from "../../../../../../../services/api-tansquery/attendance-local/department/list";
import { useAttendanceLocalStyles } from "../../../../../styles";
import { useDepartmentListTabPanelStyles } from "./styles";
import { useParams } from "react-router-dom";
import Button from "@material-ui/core/Button";
import AddCircle from "@material-ui/icons/AddCircle";
import EmptyState from "../../../../../../../Components/EmptyState";
import NewDepartment from "./components/new-department";
import { useDefaultSearchParams } from "../../../../../../../hooks/useSearchParams";
import CustomPagination from "../../../../../../../Components/pagination";

export default function DepartmentListTabPanel() {
  const [openModalCreate, setOpenModalCreate] = useState<boolean>(false);
  const { search } = useDefaultSearchParams();
  const { slug } = useParams<{ slug: string }>();
  const { classes } = useDepartmentListTabPanelStyles();
  const { classes: defaultClasses } = useAttendanceLocalStyles();
  const { data: departments } = useAttendanceLocalDepartmentList({
    unidade_slug: slug,
  });

  const handleOpenModalCreate = () => {
    setOpenModalCreate(true);
  };

  const handleCloseModalCreate = () => {
    setOpenModalCreate(false);
  };

  const noDepartments = useMemo(() => {
    return (departments?.results ?? []).length === 0;
  }, [departments]);

  const containsMisto = useMemo(() => {
    return departments?.results?.some((item) => item.misto);
  }, [departments]);

  const canAdd = useMemo(() => {
    return search && noDepartments ? false : noDepartments || !containsMisto;
  }, [containsMisto, noDepartments, search]); // needs due to cache

  const renderButtonAdd = useCallback(() => {
    if (canAdd) {
      return (
        <Button
          onClick={handleOpenModalCreate}
          startIcon={<AddCircle />}
          className={defaultClasses.addButton}
        >
          Setor
        </Button>
      );
    }
  }, [canAdd, defaultClasses]);

  return (
    <>
      <Paper elevation={3}>
        <Box className={classes.header}>
          <Box className={classes.search}>
            <SearchField placeholder="Buscar setor" />
          </Box>
          {renderButtonAdd()}
        </Box>
        <TableContainer className={defaultClasses.tableContainer}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={defaultClasses.tableTH}>Nome</TableCell>
                <TableCell className={defaultClasses.tableTH}>Órgão</TableCell>
                <TableCell className={defaultClasses.tableTH}>Ativo</TableCell>
                <TableCell className={defaultClasses.tableTH} />
              </TableRow>
            </TableHead>
            <TableBody>
              {departments?.results.map((department) => (
                <TableRow
                  hover
                  key={`department-${department.id}`}
                  role="checkbox"
                  tabIndex={-1}
                >
                  <TableCell className={defaultClasses.tableCell}>
                    {department?.misto ? "Misto" : department.setor?.nome}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    {department?.misto ? "Misto" : department.setor?.orgao.nome}
                  </TableCell>
                  <TableCell className={defaultClasses.tableCell}>
                    <Box
                      className={`${defaultClasses.badge} ${department.ativo
                        ? defaultClasses.active
                        : defaultClasses.inactive
                        }`}
                    >
                      {department.ativo ? "Sim" : "Não"}
                    </Box>
                  </TableCell>
                  <TableCell align="right" className={defaultClasses.tableCell}>
                    <DepartmentTableActions
                      item={department}
                      id={department.id}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {noDepartments && <EmptyState message="Nenhum setor encontrado." />}
        </TableContainer>
        <Box className={defaultClasses.paginationContainer}>
          <CustomPagination
            count={departments?.count}
            page={departments?.current}
            totalPages={departments?.total_pages}
          />
        </Box>
      </Paper>
      <NewDepartment
        hasMistoDepartment={true}
        handleCloser={handleCloseModalCreate}
        open={openModalCreate}
      />
    </>
  );
}
